import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';

function EditUserDetails() {

    const appState = useContext(StateContext);

    const [income, setIncome] = useState(0);
    const [egenkapital, setEgenkapital] = useState(0)

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {

        if (appState.userId) {
            const userDetailsRef = firestore.collection("users").doc(appState.userId);
            userDetailsRef.onSnapshot(doc => {
                const userDetails = {id: doc.id, ...doc.data()}
                setIncome(userDetails.income)
                setEgenkapital(userDetails.egenkapital)
            });
            
        }

    }, [appState.userId])

    async function editHandler(e) {
        e.preventDefault();
        try {
            const userRef = firestore.collection("users").doc(appState.userId);
            const data = {
                income: +income,
                egenkapital: +egenkapital
            }
            userRef.update(data);
            setMessage("Lagt til!");
        } catch (error) {
            setMessage("Kunne ikke legge til")
        }
    }

    return (
        <form onSubmit={editHandler}>
            <label>Årslønn</label>
            <input type="number" className="form-control mb-2" placeholder="Inntekt" value={income} onChange={e => setIncome(e.target.value)} />

            <label>Egenkapital</label>
            <input type="number" className="form-control mb-2" placeholder="Egenkapital" value={egenkapital} onChange={e => setEgenkapital(e.target.value)} />

            {error && <div className="alert alert-danger">{error} <span className="float-right" style={{cursor: "pointer"}} onClick={() => setError("")}>Lukk</span></div>}
            {message && <div className="alert alert-success">{message} <span className="float-right" style={{cursor: "pointer"}} onClick={() => setMessage("")}>Lukk</span></div>}
            <button className="btn btn-block btn-success">Lagre endringer</button>
        </form>
    )

}
export default EditUserDetails